import { Hr } from '@dnb/eufemia';
import type { JSX } from 'react';

import style from './index.module.css';

export default function Divider(): JSX.Element {
  return <Hr className={style['Color']} />;
}
